var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('games-header'),_c('animated-section',{attrs:{"gallery":""}},[_c('indented-container',{attrs:{"main":"","galleryList":""}},[_c('games-list',{attrs:{"games":[_vm.Apps.Homescapes, _vm.Apps.Township]}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }